module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"dialogTitle":"Create member","clubsMembersActionsCreateSuccess":"%{fullName} was successfully added to the database"},"no":{"dialogTitle":"Opprett medlem","clubsMembersActionsCreateSuccess":"%{fullName} ble lagt til i databasen"}}')
  delete Component.options._Ctor
}
